












































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import {
  Permission,
  Certificate,
  CertificatePermission,
  Principal,
} from "bancojs";
import { $api } from "@/services/ApiService";
import { debounce } from "@/services/core/Utils";

@Component
export default class AgPermissionTable extends Vue {
  @Prop()
  certificate!: Certificate;

  created() {
    this._getPermissions();
  }

  async _getPermissions() {
    try {
      this.table.loading = true;
      const permissions = await $api.client.user.certificates
        .getPermissions(this.$route.params.fingerprint)
        .toPromise();
      this.table.data = permissions.reverse();
    } catch (err) {
      console.log(err);
    } finally {
      this.table.loading = false;
    }
  }

  getPermissionString(val: CertificatePermission) {
    return val == "SIGN" ? "Firmar" : "--";
  }

  async _getPrincipals(newVal: string, oldVal: string) {
    if (
      newVal == this.table.newPermission.user_id ||
      newVal == null ||
      newVal.length < 2
    )
      return;
    try {
      this.table.loadingPrincipals = true;
      const principals = await $api.client.user.principals
        .get({ name: newVal })
        .toPromise();
      this.table.principalList = principals.content;
    } catch (err) {
      console.log(err);
    } finally {
      this.table.loadingPrincipals = false;
    }
  }

  @Watch("table.searchPrincipal")
  getPrincipals = debounce(this._getPrincipals, 300);

  async addPermission() {
    if (
      this.table.newPermission.user_id &&
      this.table.newPermission.permission
    ) {
      try {
        this.table.loading = true;
        const permission = await $api.client.user.certificates
          .addPermission(this.certificate.fingerprint, [
            this.table.newPermission,
          ])
          .toPromise();
        this.table.loading = false;
        await this._getPermissions();
        this.table.newPermission.user_id = "";
        this.table.newPermission.permission = "SIGN";
      } catch (err) {
        console.log(err);
        this.table.loading = false;
      }
    }
  }

  async deletePermission(data: Permission) {
    try {
      this.table.loading = true;
      await $api.client.user.certificates
        .destroyPermission(this.certificate.fingerprint, [data])
        .toPromise();
      this.table.loading = false;
      await this._getPermissions();
    } catch (err) {
      console.log(err);
      this.table.loading = false;
    }
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
  };

  table: {
    data: Permission[];
    headers: DataTableHeader[];
    newPermission: Permission;
    principalList: Principal[];
    searchPrincipal: string;
    loading: boolean;
    loadingPrincipals: boolean;
  } = {
    data: [],
    newPermission: {
      user_id: "",
      permission: "SIGN",
    },
    loading: true,
    loadingPrincipals: false,
    principalList: [],
    searchPrincipal: "",
    headers: [
      {
        text: "#",
        value: "$index",
      },
      {
        text: "Usuario",
        value: "user_id",
      },
      {
        text: "Acción",
        value: "permission",
      },
      {
        text: "",
        value: "$options",
        sortable: false,
        filterable: false,
      },
    ],
  };
}
